<div class="dialog-container">
    <div class="dialog-icon">
        <i [ngClass]="iconClass" aria-hidden="true"></i>
    </div>
    <div class="mb-3">
        <mat-card-title class="d-flex justify-content-center text-center"
            style="font-weight: 600; word-wrap: break-word;">{{data.Message}}
        </mat-card-title>
    </div>
    <button mat-button class="close-button" (click)="onClose()">Close</button>
</div>